import { Divider, Modal } from 'antd'
import React, { useState } from 'react'
import Input from '../../components/UI/Input'

interface modalSelectorProps {
  visible: boolean
  type: 'action' | 'objectType'
  title: string
  onSelectChange: (val: string) => void
  onClose: () => void
}

const actionOptions = [
  'visited', 'created', 'updated', 'access denied', 'deleted', 'requested', 'deactivated', 
  'closed', 'activated', 'update', 'index', 'data', 'paid', 'send_command', 'delete', 'migration_config', 
  'close', 'deactivate', 'remove server', 'migration-added', 'migration-start', 'detailed', 'error_404', 
  'new', 'migration-stop', 'filter', 'logo_image', 'start', 'jackpot_activate', 'edit', 'site_list', 'drawer_activity', 
  'game_definition', 'weekday_revenue_graph', 'month_end', 'period_revenue', 'cashier_activity', 
  'closed_game', 'report', 'current_inventory', 'distributor_list'
]

const objectTypeOptions = [
  'welcomes', 'distributors', 'gamelist', 'bingo_gamelist', 'distributor', 'distributor_servers', 'organizations', 'organization', 
  'locations', 'location', 'decks', 'deck', 'devices', 'device', 'device_versions', 'device_version', 'manufacturer_config', 'cashiers', 
  'cashier', 'system configs', 'login', 'users', 'bingo_games', 'bingo_game_jackpot_instances', 'queue_status', 'game', 'game_orderings',
  'migration_status', 'decks_management', 'bingo_game_jackpot_history', 'migration_queue', 'reports', 'bingo_active_progressives', 
  'bingo_progressive_daily', 'bingo_jackpot_winners', 'logs', 'location_topology', 'roles', 'role', 'user', 'bingo_jackpot_payrolls', 
  'cashier_activity', 'historical_transaction_log', 'game_definition', 'historical_inventory', 'revenue_by_game_graph', 'jackpot_payroll', 
  'rt_transaction_log', 'bingo_config', 'dashboard', 'rt_location_status', 'distributor_game', 'weekday_revenue_graph', 'revenue_by_device_graph', 
  'device_utilization', 'game_performance', 'daily_deposit', 'daily_deposit_sales', 'daily_revenue', 'site_list', 'user_list', 'closed_game', 'current_inventory', 
  'current_game', 'deck_status', 'month_end', 'bingo_charity_monthly_invoice', 'bingo_play', 'bingo_charities_progressive', 'account', 'revenue_by_period_graph', 
  'period_revenue', 'bingo_game_log', 'bingo_active_sites', 'bingo_distributor_monthly_statement', 'jackpot addition', 'drawer_management', 'lg861e', 
  'drawer_edit', 'drawer_cashier_management', 'drawer_activity', 'drawer_log_edit', 'site_inventory', 'bingo_lbp_monthly', 'monthly_reports', 'pos_bundle_server_management', 
  'pos_bundle_status', 'cashout_activity', 'migration', 'errors', 'bingo config', 'autocomplete', 'application'
]

function ModalSelector(props: modalSelectorProps) {
  const [search, setSearch] = useState('')
  let options = props.type === 'action' ? actionOptions : objectTypeOptions
  options.sort();
  const filteredOptions = options.filter(option => option.toLowerCase().includes(search))

  const onSelectRecord = (option: string) => {
    props.onSelectChange(option)
    props.onClose()
  }

  return (
    <>
        <Modal open={props.visible} title={props.title} onCancel={props.onClose} onOk={props.onClose}>
          <div className="modal-selector">
            <div className="modal-selector__search">
              <Input
                label="Filter"
                value={search}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                placeholder="Type to search"
              />
            </div>
            <Divider />
            <div className="modal-selector__options">
                {filteredOptions.length > 0 ? filteredOptions.map(option => (
                  <p key={option} className="modal-selector__options__item" onClick={() => onSelectRecord(option)}>
                    {option}
                  </p>
                )):(
                  <p className="modal-selector__options__item--empty">
                    The list is empty.
                  </p>
                )}
            </div>
          </div>
          
        </Modal>
    </>
  )
}

export default ModalSelector
